import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { Glyph } from "./Glyph";
import { Astrolabe } from "./Astrolabe";
import { SERVICES, mailto } from "../../content";

const ServiceCard = ({ s, wide }) => (
  <article
    data-testid={`service-card-${s.id}`}
    className={`service-card group relative h-full overflow-hidden rounded-[28px] border border-[#B59A5B]/25 bg-[#18222D] p-7 sm:p-10 flex flex-col ${wide ? "lg:grid lg:grid-cols-12 lg:gap-10 lg:items-end" : ""}`}
  >
    {wide && <Astrolabe className="absolute -right-40 -bottom-48 w-[560px] h-[560px] text-[#B59A5B]/15 pointer-events-none" reverse />}
    <div className={`relative flex flex-col h-full ${wide ? "lg:col-span-7" : ""}`}>
      <div className="flex items-start justify-between">
        <Glyph type={s.glyph} className="w-14 h-14 text-[#C9AD6A] transition-transform duration-700 group-hover:rotate-[30deg]" />
        <span className="font-display italic text-5xl sm:text-6xl text-[#B59A5B]/45 leading-none">{s.numeral}</span>
      </div>
      <p className="mt-10 font-caps text-[11px] tracking-[0.3em] uppercase text-[#C9AD6A]">{s.subtitle}</p>
      <h3 className="mt-3 font-display text-4xl sm:text-5xl font-light text-[#FAF6ED] leading-[1.05]">{s.title}</h3>
      <p className="mt-5 text-[15px] sm:text-base leading-relaxed text-[#FAF6ED]/80 font-body max-w-xl">{s.body}</p>
    </div>
    <div className={`relative mt-8 ${wide ? "lg:col-span-5 lg:mt-0" : "mt-auto pt-8"}`}>
      {s.note && (
        <p data-testid="service-symbolic-note" className="mb-7 border-l border-[#B59A5B]/60 pl-4 text-sm leading-relaxed text-[#FAF6ED]/75 italic font-display text-[17px]">
          {s.note}
        </p>
      )}
      <ul className="flex flex-wrap gap-2">
        {s.tags.map((t) => (
          <li key={t} className="rounded-full border border-[#FAF6ED]/15 px-3.5 py-1.5 text-xs text-[#FAF6ED]/80 font-body">{t}</li>
        ))}
      </ul>
      <a
        href={mailto(`Inquiry: ${s.title}`)}
        data-testid={`service-inquire-${s.id}`}
        className="mt-8 inline-flex items-center gap-2 font-caps text-xs tracking-[0.25em] uppercase text-[#E2CC92] link-underline"
      >
        Inquire by email <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    </div>
  </article>
);

export const Services = () => (
  <section id="services" tabIndex={-1} data-testid="services-section" className="relative py-24 sm:py-36 outline-none">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-14 sm:mb-20">
        <Reveal className="lg:col-span-7">
          <p className="font-caps text-[11px] sm:text-xs tracking-[0.35em] uppercase text-[#C9AD6A] flex items-center gap-3">
            <span className="h-px w-10 bg-[#B59A5B]/70" /> Our Services
          </p>
          <h2 className="mt-6 font-display font-light text-5xl sm:text-6xl lg:text-7xl text-[#FAF6ED] leading-[1]">
            Three paths <span className="italic text-[#C9AD6A]">of counsel.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5">
          <p className="text-base sm:text-lg leading-relaxed text-[#FAF6ED]/80 font-body">
            Each consultation is personal. Details and arrangements are discussed directly, by email, once you reach out.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 sm:gap-6">
        <Reveal className="lg:col-span-6"><ServiceCard s={SERVICES[0]} /></Reveal>
        <Reveal className="lg:col-span-6" delay={0.12}><ServiceCard s={SERVICES[1]} /></Reveal>
        <Reveal className="lg:col-span-12" delay={0.1}><ServiceCard s={SERVICES[2]} wide /></Reveal>
      </div>
    </div>
  </section>
);
